var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header",attrs:{"name":"home-header"}},[_c('img',{staticClass:"logo",attrs:{"src":require("../../../assets/concierge_logo.png")}}),_vm._v(" "),_c('div',{staticClass:"logout-button",on:{"click":_vm.logout}},[_vm._v("로그아웃")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-114b4c84","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/molecules/home/HomeHeader.vue
// module id = null
// module chunks = 